<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import { CountUp } from 'countup.js';

const props = defineProps({
  startVal: {
    type: Number,
    default: 0,
  },
  endVal: {
    type: Number,
    default: NaN,
  },
  prefix: {
    type: String,
    default: '',
  },
  suffix: {
    type: String,
    default: '',
  },
  duration: {
    type: Number,
    default: 3,
  },
  scrollSpy: {
    type: Boolean,
    default: true,
  },
  scrollSpyOnce: {
    type: Boolean,
    default: true,
  },
  scrollSpyDelay: {
    type: Number,
    default: 0,
  },
});

const el = ref();
const decimalPlaces = 0;
const decimal = '.';
const separator = ',';

const formatNumber = (num: number): string => {
  const neg = (num < 0) ? '-' : '';
  let result = Math.abs(num).toFixed(decimalPlaces);
  result += '';
  const x = result.split('.');
  let x1 = x[0];
  const x2 = x.length > 1 ? decimal + x[1] : '';
  let x3 = '';
  let j = 0;

  for (let i = 0, len = x1.length; i < len; ++i) {
    if (i !== 0 && (j % 3) === 0) {
      x3 = separator + x3;
    }
    j++;
    x3 = x1[len - i - 1] + x3;
  }

  x1 = x3;

  return neg + props.prefix + x1 + x2 + props.suffix;
}

let instance: CountUp;

const init = () => {
  if (isNaN(props.endVal) || instance) {
    return;
  }

  instance = new CountUp(el.value, props.endVal, {
    startVal: props.startVal,
    duration: props.duration,
    suffix: props.suffix,
    enableScrollSpy: props.scrollSpy,
    scrollSpyOnce: props.scrollSpyOnce,
    scrollSpyDelay: props.scrollSpyDelay,
  });

  if (!props.scrollSpy) {
    instance.start();
  }
}

watch(() => props.endVal, () => {
  if (!instance) {
    init();
  }
});

onMounted(() => {
  init();
});
</script>

<template>
  <span class="count-to" ref="el">
    {{ formatNumber(props.endVal) }}
  </span>
</template>

<style lang="scss" scoped>
</style>
